module.exports = __webpack_public_path__ + "static/img/dt.b43a211c.png";